// 009: the cart, address and payment (P-CART-1..9). Phones get the pushed screen's app bar.
import { View } from "react-native";

import { CartScreen } from "@/checkout/CartScreen";
import { AppBar } from "@/shell/chrome/AppBar";
import { useChromeKind } from "@/shell/chrome/useChromeKind";

export default function Cart() {
  const mobile = useChromeKind() === "mobile";
  return (
    <View style={{ flex: 1 }}>
      {mobile ? <AppBar title="Cart" /> : null}
      <CartScreen />
    </View>
  );
}
